import classnames, { ArgumentArray } from 'classnames';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * cn(): classnames + tailwind-merge
 *
 * Extended to recognize custom text-* font-size utilities from theme.css so that
 * callers can override the base font-size via className (e.g. text-heading-m overrides text-lg).
 * Without this, tailwind-merge misclassifies custom text-* tokens as text-color and silently drops them.
 * See: https://github.com/dcastil/tailwind-merge/issues/593
 *
 * For VSCode hint → add in settings.json:
 * "tailwindCSS.experimental.classRegex": [
 *   ["(?:tw|clsx|cn)\\(([^;]*)[\\);]", "[`'\"`]([^'\"`;]*)[`'\"`]"]
 * ]
 */
const twMerge = extendTailwindMerge({
	extend: {
		classGroups: {
			'font-size': [
				'text-heading-l',
				'text-heading-m',
				'text-heading-m-compact',
				'text-md',
				'text-base-listing',
				'text-button',
				'text-label-base',
				'text-label-sm',
			],
		},
	},
});

export const cn = (...inputs: ArgumentArray): string => {
	return twMerge(classnames(inputs));
};
